//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getGenerativeAiRightsRequest } from '@apis/generative-ai/generativeAiApi';
import Cuid from '@models/Cuid';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import {
  RightsRequestTCUrlParams,
  useRightsRequestTCMessage,
} from '@uia/rights/hooks/useRightsRequestTCMessage';
import { useRightsRequestTCUrl } from '@uia/rights/hooks/useRightsRequestTCUrl';

export interface GenerativeAiRightsRequestParams
  extends RightsRequestTCUrlParams {
  approvalPhrase: string | undefined;
  cuid: Cuid;
}

export const useGenerativeAiRightsRequestQuery = ({
  approvalPhrase = '',
  cuid,
  locale,
  rightsRequestText,
}: GenerativeAiRightsRequestParams) => {
  const rightsRequestTCMessage = useRightsRequestTCMessage({
    locale,
    rightsRequestText,
  });
  const rightsRequestTCUrl = useRightsRequestTCUrl();

  return useQuery({
    enabled: false,
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsRightsGenerativeAiRights,
      cuid,
      approvalPhrase,
      rightsRequestTCUrl,
      rightsRequestTCMessage,
    ],
    queryFn: async ({ signal }) =>
      getGenerativeAiRightsRequest(
        {
          cuid,
          approvalPhrase,
          additionalText: `${rightsRequestTCMessage ?? ''} For full terms and conditions, visit ${rightsRequestTCUrl}`,
        },
        { signal },
      ),
  });
};
